<div class="dates-filter-container">
  <md2-datepicker
    [(ngModel)]="startDate"
    format="dd/MM/y"
    placeholder="Start date"
    (change)="startDateChanged()"
    class="margin"
    [openOnFocus]="true"
  ></md2-datepicker>
  <md2-datepicker
    [(ngModel)]="endDate"
    format="dd/MM/y"
    placeholder="End date"
    (change)="endDateChanged()"
    [openOnFocus]="true"
  >
  </md2-datepicker>
  <div>
    3AM
    <md-slide-toggle
      [checked]="midnightMode"
      (change)="dayStartChanged($event)"
    ></md-slide-toggle>
    12AM
  </div>
  <button
    md-tooltip="Reload programs"
    md-raised-button
    (click)="dateChanged()"
    style="margin-left: 10px; height: 36px; margin-top: 14px; min-width: 48px"
  >
    <md-icon>refresh</md-icon>
  </button>
</div>



// WEBPACK FOOTER //
// ./src/app/components/date-filter-picker/date-filter-picker.component.html